import store from '@/store'
import Model from '@/core/classes/Model'

export default class User extends Model {
  $retrievables () {
    return [
    ]
  }

  /**
   * User properties availability to CSV downloader
   *
   * @returns {Array}
   */
  static csvHeaders () {
    return store.getters['app/environment'].getFeature('ACCOUNTS_CSV_DOWNLOAD_COLUMNS')
  }

  /**
   * Default csv headers to be selected and downloaded through quick download
   *
   * @returns {Array}
   */
  static defaultCsvHeaders () {
    return store.getters['app/environment'].getFeature('ACCOUNTS_CSV_DOWNLOAD_DEFAULT_COLUMNS')
  }

  /**
   * Transform csv header label
   *
   * @param {String} header
   *
   * @returns {String}
   */
  static csvHeadersTransformer (header) {
    const headers = {
      'links.check': 'tech_check',
      'links.game': 'game',
      'assessments.0.location': 'assessment_location',
      'assessments.0.assessment_group': 'assessment_group',
      'assessments.0.assessment_date': 'assessment_login_window',
      'assessments.0.created_by': 'assessment_created_by',
      'assessments.0.created_at': 'assessment_created_at',
      'assessments.0.updated_by': 'assessment_updated_by',
      'assessments.0.updated_at': 'assessment_updated_at'
    }

    return headers.hasOwnProperty(header)
      ? headers[header]
      : header
  }

  /**
   * Generate links for a user
   *
   * @return {Object}
   */
  getLinksAttribute () {
    return {
      'check': this.get('token', false)
        ? store.getters['app/environment'].get('servers').find('tech_check').generateUrls({
          postfix: `/?token=${this.get('token', '-')}`
        })
        : [ '-' ],
      'game': this.get('token', false)
        ? store.getters['app/environment'].get('servers').find('game').generateUrls({
          postfix: `/?token=${this.get('token', '-')}`
        })
        : [ '-' ]
    }
  }

  /**
   * Retrieve the active assessment
   */
  getActiveAssessment () {
    return this.get('assessments').find((assessment) => {
      return assessment.is_active
    })
  }
}
